export default __webpack_public_path__ + "static/media/trr-drink-tea-chailatte.e66d2cd9.png";